import React, { useRef, useState } from "react";
import { FaFile } from "react-icons/fa";
import { StyledFile } from "./TreeFile.style";
import { useTreeContext } from "../state/TreeContext";
import { ActionsWrapper, StyledName } from "../Tree.style.js";
import { PlaceholderInput } from "../TreePlaceholderInput";
import Swal from "sweetalert2";

import { FILE } from "../state/constants";
import FILE_ICONS from "../FileIcons";
import { FaEdit, FaHistory, FaTrash } from "react-icons/fa";
import { useCourseId } from "hooks/router/useUrlParams";

const File = ({ name, id, projectId, node, format, url, currFile, starterFile }) => {
  const courseId = useCourseId()
  const { dispatch, onNodeClick } = useTreeContext();
  const [isEditing, setEditing] = useState(false);
  const ext = useRef("");

  let splitted = name?.split(".");
  ext.current = splitted[splitted.length - 1];

  const toggleEditing = () => setEditing(!isEditing);
  const commitEditing = (name) => {
    dispatch({
      type: FILE.EDIT,
      payload: {
        id,
        format,
        url,
        name,
      },
    });
    setEditing(false);
  };
  const viewHistory = () => {
    console.log(id)
    console.log(projectId)
    const historyUrl = `/${courseId}/ide/history/${projectId}/${id}`;
    window.open(historyUrl, "_blank");
  }
  const commitDelete = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch({ type: FILE.DELETE, payload: { id } });
        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };
  const handleNodeClick = React.useCallback(
    (e) => {
      e.stopPropagation();
      // @ts-ignore
      onNodeClick({ node });
    },
    [node]
  );
  const handleCancel = () => {
    setEditing(false);
  };

  return (
    <StyledFile
      style={{
        background: currFile?.id === id ? "#F3F3F3" : "none",
      }}
      className="tree__file"
    >
      {isEditing ? (
        <PlaceholderInput
          name={name}
          type="file"
          style={{ paddingLeft: 0 }}
          defaultValue={name}
          onSubmit={commitEditing}
          onCancel={handleCancel}
        />
      ) : (
        <ActionsWrapper>
          <StyledName onClick={handleNodeClick}>
            {FILE_ICONS[ext.current] ? (
              FILE_ICONS[ext.current]
            ) : (
              <FaFile />
            )}
            &nbsp;&nbsp;{name}
          </StyledName>
          <div className="actions">
            {!starterFile ? (
              <>
                <FaEdit onClick={toggleEditing} />
                <FaTrash onClick={commitDelete} />
                <FaHistory onClick={viewHistory} />
              </>
            ) : 
              <>
              <FaHistory onClick={viewHistory} />
              </>
            }
          </div>
        </ActionsWrapper>
      )}
    </StyledFile>
  );
};

export { File };
